import { render } from "./Menus.vue?vue&type=template&id=b070a342&ts=true"
import script from "./Menus.vue?vue&type=script&lang=ts"
export * from "./Menus.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__